import { Component } from '@angular/core';
import { CurrentUserService } from '../../core/services/user/current-user.service';
import { CommonModule } from '@angular/common';
import { NotificationService } from '../../core/services/notification/notification.service';
import { NotificationList } from '../../core/models/notification/notification-list.model';
import { StatusUtils } from '../../utils/status-utils';
import { environment } from '../../../environments/environment';
import { SignalRService } from '../../core/services/signalR/signalR';
import { Router } from '@angular/router';
import { AuthService } from '../../core/services/user/auth.service';
import { TranslateService, TranslateModule } from '@ngx-translate/core';
import { UserSessionModel } from '../../core/models/user/current-user.model';
declare var KTMenu: any;

@Component({
  selector: 'app-header',
  standalone: true,
  imports: [CommonModule, TranslateModule],
  templateUrl: './header.component.html',
  styleUrl: './header.component.scss',
})
export class HeaderComponent {
  constructor(
    private currentUserService: CurrentUserService,
    private notificationService: NotificationService,
    private signalRService: SignalRService,
    private router: Router,
    private authService: AuthService,
    private translateService: TranslateService
  ) {
    // this.createNotificationListSignalRConnection();
    this.translateService.setDefaultLang('tr');
    this.translateService.use('tr');
  }

  currentUser: UserSessionModel | null = null;
  notificationList: NotificationList[] = [];
  unReadNotificationMessageCount: number = 0;
  statusClass: string = '';
  statusText: string = '';

  ngAfterViewInit(): void {
    if (KTMenu) {
      KTMenu.createInstances();
    }
    this.applyStoredTheme();
  }

  ngOnInit() {
    this.currentUser = this.currentUserService.GetSession();
  }

  protected async createNotificationListSignalRConnection() {
    const signalRBasePath = `${environment.apiLocations.notification}`.split(
      '/api/v1'
    )[0];
    const hubUrl = signalRBasePath + '/notification-hub';
    this.signalRService.connect(hubUrl);
    this.signalRService.on('receiveNotificationAdded', (message) => {
      try {
        const parsedNotification = JSON.parse(message);
        if (parsedNotification) {
          const notification = {
            id: parsedNotification.Id,
            createdDate: parsedNotification.CreatedDate,
            customerCode: parsedNotification.CustomerCode,
            email: parsedNotification.Email,
            isRead: parsedNotification.IsRead,
            message: parsedNotification.Message,
            userId: parsedNotification.UserId || [],
          };
          this.unReadNotificationMessageCount++;
          this.notificationList = [notification, ...this.notificationList].sort(
            (a, b) => {
              return (
                new Date(b.createdDate).getTime() -
                new Date(a.createdDate).getTime()
              );
            }
          );
        }
      } catch (error) {
        console.error('Error: ', error);
      }
    });
  }

  getNotificationList(): void {
    this.notificationService.notificationList().subscribe({
      next: (res) => {
        this.notificationList = res;
        this.getUnReadNotificationMessageCount();
      },
      error: () => {},
    });
  }

  getUnReadNotificationMessageCount(): void {
    this.notificationService.unReadNotificationMessageCount().subscribe({
      next: (res) => {
        this.unReadNotificationMessageCount = res;
      },
    });
  }

  checkNotification(id: string): void {
    this.notificationService.readNotification(id).subscribe({
      next: () => {
        this.getNotificationList();
        this.getUnReadNotificationMessageCount();
      },
    });
  }

  readAllNotification(): void {
    this.notificationService.readAllNotification().subscribe({
      next: () => {
        this.getNotificationList();
        this.getUnReadNotificationMessageCount();
      },
    });
  }

  deleteNotification(id: string): void {
    this.notificationService.deleteNotification(id).subscribe({
      next: () => {
        this.getNotificationList();
        this.getUnReadNotificationMessageCount();
      },
    });
  }

  deleteAllNotification(): void {
    this.notificationService.deleteAllNotification().subscribe({
      next: () => {
        this.getNotificationList();
        this.getUnReadNotificationMessageCount();
      },
    });
  }

  setTheme(mode: string) {
    localStorage.setItem('data-bs-theme', mode);
    localStorage.setItem('data-bs-theme-mode', mode);
    document.documentElement.setAttribute('data-bs-theme', mode);
  }

  private applyStoredTheme(): void {
    const storedTheme = localStorage.getItem('data-bs-theme');
    if (storedTheme) {
      document.documentElement.setAttribute('data-bs-theme', storedTheme);
    }
  }

  logout() {
    this.authService.logout().subscribe({
      next: () => {},
    });
  }
}
